import {Enumify} from "./Enumify";
import {formatPaymentTypeToForm} from "../helpers/businessHelper";

export default class PaymentTypeEnum extends Enumify<string> {
    static readonly subscription = new PaymentTypeEnum('SUBSCRIPTION');
    static readonly transfer = new PaymentTypeEnum('TRANSFER');
    static readonly event = new PaymentTypeEnum('EVENT');
    static readonly credit = new PaymentTypeEnum('CREDIT');
    static readonly event_penality_late = new PaymentTypeEnum('EVENT_PENALITY_LATE');
    static readonly event_penality_absence = new PaymentTypeEnum('EVENT_PENALITY_ABSENCE');
    static readonly _ = this.closeEnum();

    constructor(value: string) {
        super();
        this.value = value;
    }

    get translated() {
        return formatPaymentTypeToForm(this)
    }
}
